import { render } from "./PostCommentList.vue?vue&type=template&id=31582fa2"
import script from "./PostCommentList.vue?vue&type=script&lang=js"
export * from "./PostCommentList.vue?vue&type=script&lang=js"
script.render = render

export default script